export default "__VITE_ASSET__B2C5jpR2__"